export default {
  fansDescriptionFirst: "Think you can outsmart the analysts?",
  fansDescriptionLast: "Prove it. Win prizes.",
  fansTitle: "Fan Contests",
  forumsDescription:
    "Discuss all aspects of the team with members of the community.",
  forumsTitle: "Exclusive Forums",
  newsDescription:
    "Enjoy Premium articles and exclusive team coverage written by expert analysts.",
  newsTitle: "Breaking News"
};
